export const langBoards = {
  fr: {
    boards: 'Boards',
    deleteAlert: ` fait partie de plusieurs gréements enregistrés. Elle ne peut pas être supprimée.`,
  },
  eng: {
    boards: 'Boards',
    deleteAlert: ` is part of several registered rigs. It cannot be deleted.`,
  },
}
